export default class Department {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;

        this.introSection = this.element.querySelector(".intro__banner");
        this.init();
    }
    init() {
        this.setSectionBg();
    }
    setSectionBg() {
        let bgUrl = this.introSection.dataset.bg;
        this.introSection.style.backgroundImage = `url(${bgUrl})`;
    }
}
